import React from 'react';


const CreditCardInput = ({ input, translate, meta: { touched, error, warning, asyncValidating } }) => {
  return(
    <div className="col">
    <div className={asyncValidating ? 'async-validating' : ''}>
    {touched && error && <div><span className="text-danger">{translate(error)}</span></div>}
      <div className="row">
        <div className="col pr-0" >
          <input {...input} className="form-control form-control-payment-number text-md-left"  type="phone" maxLength="16" placeholder="XXXX XXXX XXXX XXXX" />
        </div>
      </div>
    </div>
    </div>
  )
}
export default CreditCardInput;



// WEBPACK FOOTER //
// ./src/components/Payment/CreditCardInput.js